module.exports = __webpack_public_path__ + "static/media/Hills_of_Crestwood_SecondAmendedRevBylaws.d8ab49f9.pdf";